import React from 'react';
import { makeStyles, createStyles } from '@material-ui/styles';
import { Theme, IconButton, Button } from '@material-ui/core';
import { FlagsContext } from '../../context';
import { HamburgerIcon } from '../Icons';

interface MenuLogoProps {
  menuClickCallback?: () => void;
  Icon?: React.ReactNode;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles<string, { EnabledImprovedLayouts: boolean }>({
    menuButtonContainer: {
      [theme.breakpoints.up('md')]: {
        display: 'none',
      },
      paddingRight: ({ EnabledImprovedLayouts }) =>
        EnabledImprovedLayouts && theme.spacing(2),
    },
    menuButton: {
      paddingLeft: 0,
    },
    hamburgerMenu: {
      minWidth: 0,
    },
    logo: {
      cursor: 'pointer',
      fontSize: '35px',
      color: theme.palette.primary.contrastText,
    },
  }),
);

const MenuLogo = (props: MenuLogoProps) => {
  const {
    menuClickCallback,
    // by default we use the hamburger icon, but we can pass in a custom icon
    // e.g. toggle the secondary sidebar menu needs to have a different icon
    Icon = HamburgerIcon,
  } = props;
  const { EnabledImprovedLayouts } = React.useContext(FlagsContext);
  const classes = useStyles({ EnabledImprovedLayouts });

  return (
    <div className={classes.menuButtonContainer}>
      {EnabledImprovedLayouts ? (
        <Button
          variant="contained"
          color="secondary"
          onClick={menuClickCallback}
          className={classes.hamburgerMenu}
        >
          <Icon />
        </Button>
      ) : (
        <IconButton
          className={classes.menuButton}
          color="inherit"
          onClick={menuClickCallback}
          id="menu-hamburger"
        >
          <Icon />
        </IconButton>
      )}
    </div>
  );
};

export default MenuLogo;
